var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('FilterFields', {
    attrs: {
      "fields": [{
        type: 'number',
        label: 'Código',
        field: 'id_lista_preco_servico'
      }, {
        type: 'text',
        label: 'Descrição',
        field: 'descricao'
      }, {
        type: 'select',
        label: 'Status',
        field: 'status',
        options: ['Ativo', 'Inativo']
      }]
    }
  }), _c('TableApp', {
    ref: "listaPrecos",
    attrs: {
      "titulo": "Lista de Preços de Serviços",
      "acaoBtn": "/#/lista-precos-servicos/nova",
      "textoBtn": "Nova",
      "api-url": "/servicos/lista-preco",
      "fields": _vm.fields,
      "classFilterColumn": "descricao",
      "perPage": 10
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field === 'descricao' ? _c('span', {
          attrs: {
            "slot": "descricao"
          },
          slot: "descricao"
        }, [_c('span', {
          staticClass: "pl-0 pt-8"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('a', {
          staticClass: "text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"
        }, [_vm._v(" " + _vm._s(props.rowData.descricao.substr(0, 50)) + " ")])])])]) : _vm._e(), props.field === 'status' ? _c('span', {
          attrs: {
            "slot": "status"
          },
          slot: "status"
        }, [props.rowData.status ? _c('span', {
          staticClass: "label label-lg label-inline label-light-success"
        }, [_vm._v(" Ativo ")]) : _c('span', {
          staticClass: "label label-lg label-inline label-light-danger"
        }, [_vm._v(" Inativo ")])]) : _vm._e(), props.field === 'actions' ? _c('span', {
          attrs: {
            "slot": "actions"
          },
          slot: "actions"
        }, [_c('div', {
          staticClass: "row-actions",
          staticStyle: {
            "text-align": "right !important"
          }
        }, [_c('router-link', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.bottom",
            value: 'Editar',
            expression: "'Editar'",
            modifiers: {
              "hover": true,
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2",
          attrs: {
            "to": {
              name: 'listaPrecoServicoUpdate',
              params: {
                id_lista_preco_servico: props.rowData.id_lista_preco_servico
              }
            }
          }
        }, [_c('Pencil', {
          attrs: {
            "size": 16,
            "title": "Editar"
          }
        })], 1), _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.bottom",
            value: 'Excluir',
            expression: "'Excluir'",
            modifiers: {
              "hover": true,
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-danger btn-hover-danger btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.excluir(props.rowData);
            }
          }
        }, [_c('TrashCanIcon', {
          attrs: {
            "size": 16
          }
        })], 1)], 1)]) : _vm._e()];
      }
    }])
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };